import { render, staticRenderFns } from "./CustomerUserCreateDetailsTab.vue?vue&type=template&id=026b9011"
import script from "./CustomerUserCreateDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerUserCreateDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports